module.exports = __webpack_public_path__ + "static/media/v13.75bf202e.png";